<template>
    <div class="step-template">
        <div class="text-wrapper">
            <div class="left-wrapper">
                <h1>Der erste Tag in der App</h1>

                <p class="h2">Alles ist vorbereitet...<br />Beginnen wir mit dem ersten Tag</p>
            </div>
        </div>

        <MobileTemplate @app-step-from-mobile-template="actualStep" weiterBtn :appStep="appStep" />
    </div>
</template>

<script>
export default {
    data(){
        return {
            appStep: 9
        }
    },

    methods: {
        actualStep() {
            this.$emit('app-step', ++this.appStep)
        }
    }
}
</script>

